import React from "react";

import {SmallDesc} from "@ui/descriptions/SmallDesc";

import styles from "./styles.module.scss";

export const ChartLabel = ({labelsList}) => {
  return (
    <div className={styles.chartLabel}>
      {labelsList &&
        labelsList.length > 0 &&
        labelsList.map((label) => (
          <div key={label.id}>
            <img
              src={label.icon}
              alt={label.name}
            />

            <SmallDesc>
              <span>{label.name}</span>
            </SmallDesc>
          </div>
        ))}
    </div>
  );
};
